// 导出 g-base 中的 types
export * from '@antv/g-base/lib/types';
//# sourceMappingURL=types.js.map